<template>
  <div class="guide-wrapper">
    <div class="guide-banner">
      <h1>{{ $t('you-yan-chan-pin-zhi-nan') }}</h1>
      <p class="guide-subtitle">
        {{ $t('zai-zhe-li-ni-ke-yi-le-jie-you-yan-chan-pin') }}
      </p>
      <a-input
        v-model:value="title__icontains"
        :placeholder="$t('qing-shu-ru-wen-ti-guan-jian-ci')"
        class="guide-search"
        allowClear
        @change="debounceSearch"
      >
        <template #prefix>
          <iconpark-icon name="search" class="text-font-50"></iconpark-icon>
        </template>
      </a-input>
    </div>
    <div class="container">
      <p v-show="showResult.length" class="guide-result">
        {{ showResult }}
      </p>
      <div class="guide-wrapper-list">
        <a-card v-for="item in content" :key="item.id" :bordered="false" class="guide-item">
          <template #cover>
            <img
              loading="lazy"
              class="h-[216px] object-cover"
              :alt="item.title"
              :src="item.cover_url"
            />
          </template>
          <a-card-meta :title="item.title">
            <template #description>
              <p class="guide-desc">
                {{ item.description }}
              </p>
              <a-button class="guide-action" @click="detail(item.id)">
                {{ $t('cha-kan-geng-duo') }}
              </a-button>
            </template>
          </a-card-meta>
        </a-card>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts" name="ProductGuide">
import { debounce } from 'lodash-es';
import { reqGetDocList, type IHelpDoc } from '~/api';
import { PageKey } from '~/constants/page';

const router = useRouter();
const content = ref<IHelpDoc[]>([]);
const title__icontains = ref('');
const showResult = ref('');

const { data } = await useAsyncData(async () => {
  const res = await reqGetDocList();
  return res.data?.results || [];
});
content.value = data.value || [];
const { $t } = useNuxtApp();

const onSearch = async () => {
  const res = await reqGetDocList(title__icontains.value);
  content.value = res.data?.results || [];
  showResult.value = title__icontains.value.length
    ? $t('zhao-dao-yu-titleicontainsvalue-xiang-guan-jie-guo-gong-contentvaluelength-tiao', [
        title__icontains.value,
        content.value.length,
      ])
    : '';
};

const debounceSearch = debounce(onSearch, 500);

const detail = (id: number) => {
  router.push({
    name: PageKey.HELP_CENTER_DETAIL,
    params: { id },
  });
};

const guideBannerBg = useCssBgUrl(
  '/youyan-platform/png/guide-bg.png?x-oss-process=image/format,webp',
);
</script>

<style lang="scss" scoped>
.guide-wrapper {
  @apply min-h-full;
}
.guide-banner {
  @apply flex flex-col justify-center items-center h-[370px];
  background: v-bind('guideBannerBg') no-repeat center center;
  background-size: 100% 100%;
  h1 {
    @apply text-[50px] text-font-1 m-0;
  }
  .guide-subtitle {
    @apply text-[20px] text-font-1 opacity-50 mt-[12px] mb-[36px];
  }
  .guide-search {
    @apply w-[620px] h-[60px] p-[20px] rounded-[30px];
    box-shadow: 0px 6px 20px 0px rgba(21, 46, 106, 0.03);
    border: 1px solid var(--back-4);
    input {
      @apply text-[18px] text-font-1;
    }
    input::placeholder {
      @apply text-[18px] text-font-1 opacity-40;
    }
  }

  .ant-input-prefix,
  .ant-input-suffix {
    @apply text-[28px] text-font-1 opacity-80 mr-[8px];
  }
  .ant-input-suffix {
    @apply mr-0;
    .ant-input-clear-icon {
      @apply text-[20px];
    }
  }
}
.container {
  @apply w-[1230px] m-auto;
}
.guide-wrapper-list {
  @apply grid grid-cols-3 gap-x-[36px] gap-y-[36px];
}
.guide-result {
  @apply text-[20px] leading-[1.4] text-font-1 opacity-50 mt-0 mb-[30px];
}
.guide-item {
  @apply w-[386px] h-[396px] rounded-[10px];
  transition: all 0.2s ease;
  box-shadow: 0px 2px 20px 0px rgba(21, 46, 106, 0.08) !important;
  border: 1px solid #ffffff;
  &:hover {
    transform: translateY(-6px);
  }
  .ant-card-body {
    @apply p-[20px];
  }
  .ant-card-meta {
    @apply m-0;
  }
  .guide-title {
    @apply text-[20px] text-font-1 leading-[28px] font-[600];
  }
  .guide-desc {
    @apply text-[14px] text-font-1 opacity-50 h-[48px] line-clamp-2 leading-[24px] text-justify mt-[12px] mb-[24px];
  }
  .guide-action {
    @apply py-[0px] px-[17px] h-[28px] leading-[24px] text-[13px] cursor-pointer;
  }
}
</style>
